import { useEffect } from "react";
import { createPortal } from "react-dom";
import styles from "./nps-survey-modal.module.css";

export function NpsSurveyModal({ onClose, url }: { onClose: () => void; url: string }) {
	useEffect(() => {
		const messageListener = (event: MessageEvent) => {
			if (
				event.data.message === "close-panorama-survey-modal" ||
				(event.data.message === "submit-panorama-survey-score" && event.data.npsSurveyData?.score == null)
			) {
				onClose();
			}
		};
		window.addEventListener("message", messageListener);
		return () => window.removeEventListener("message", messageListener);
	}, []);

	return createPortal(
		<div className={styles.modalWrapper}>
			<iframe className={styles.iframe} src={url} />
		</div>,
		document.body,
	);
}
